"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("./Icon"));

var ProgressIndicator = function ProgressIndicator(_ref) {
  var _cx;

  var block = _ref.block,
      className = _ref.className,
      dots = _ref.dots,
      size = _ref.size,
      style = _ref.style,
      title = _ref.title;

  if (dots) {
    return _react.default.createElement("div", {
      className: className,
      style: (0, _extends2.default)({
        fontSize: size && size
      }, style)
    }, title && _react.default.createElement("div", null, title), _react.default.createElement("div", null, _react.default.createElement("div", {
      className: "inline-block animated flash infinite",
      style: {
        animationDelay: '1.2s'
      }
    }, "."), _react.default.createElement("div", {
      className: "inline-block animated flash infinite",
      style: {
        animationDelay: '0.8s',
        marginLeft: '0.1em'
      }
    }, "."), _react.default.createElement("div", {
      className: "inline-block animated flash infinite",
      style: {
        animationDelay: '0.4s',
        marginLeft: '0.1em'
      }
    }, ".")));
  }

  var progressIndicatorClassName = (0, _classnames.default)((_cx = {}, (0, _defineProperty2.default)(_cx, className, className), (0, _defineProperty2.default)(_cx, 'block', block), _cx));
  var iconClassName = (0, _classnames.default)({
    'inline-block spin': true,
    'grey-xd margin-right-1': !block
  });
  size = size || (block ? '8rem' : '1.55rem');
  return _react.default.createElement("span", {
    style: (0, _extends2.default)({}, style),
    className: progressIndicatorClassName
  }, _react.default.createElement(_Icon.default, {
    className: iconClassName,
    icon: "ios-sync",
    fontSize: size
  }), title && _react.default.createElement("span", {
    className: block && 'block'
  }, title));
};

process.env.NODE_ENV !== "production" ? ProgressIndicator.propTypes = {
  block: _propTypes.default.bool,
  className: _propTypes.default.string,
  dots: _propTypes.default.bool,
  size: _propTypes.default.any,
  style: _propTypes.default.object,
  title: _propTypes.default.string
} : void 0;
ProgressIndicator.defaultProps = {
  dots: false
};
var _default = ProgressIndicator;
exports.default = _default;